import React from 'react'
import css from './style.scss'
import Button from 'components/shared/button'
import CloseIcon from 'react-icons/lib/md/close'
import {Motion, spring} from 'react-motion';
export default (props)=>(
  <div className={css.storiPromoContainer}>

  <Motion defaultStyle={{marginTop: 100, opacity:0}} style={{opacity:spring(1), marginTop: spring(0)}}>
    {style =>{
      return (
        <div className={css.storiPromo} style={{opacity:style.opacity,  transform: "translate(0, "+style.marginTop+"px)"}}>
          <div onClick={props.onClose} className={css.close}><CloseIcon size={24}/></div>
          <div className={css.avatar}>
            <img alt="{props.account.name}'s avatar" src={props.account.picture ? props.account.picture : "/assets/placeholder/normal.png"}/>
          </div>
          <div className={css.text}>
            <h3>Hey, hi there!</h3>
            <p>
              <b>{props.account.name}</b> is using <b>{process.env.REACT_APP_NAME}</b> to backup all his Instagram Stories and insights and share them with you.
            </p>
            <Button to="/" white>Learn More</Button>
          </div>
        </div>
      )
    }
    }
  </Motion>


  </div>
)



// WEBPACK FOOTER //
// ./src/components/adventures/public/storiPromo.js